import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './Text.module.scss'

const Text = ({ size, children, className, htmlTag, ...rest }) => {
	return React.createElement(
		htmlTag,
		{ className: classnames(styles.root, className, styles[size]), ...rest },
		children
	)
}

Text.propTypes = {
	size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
	htmlTag: PropTypes.oneOf(['div', 'span', 'p', 'section', 'dl', 'dt', 'dd', 'label', 'li']),
	className: PropTypes.string,
	children: PropTypes.node
}

Text.defaultProps = {
	size: 'md',
	htmlTag: 'div'
}

export default Text
